<template>
  <nav>
    <page-button id="goto-hub" class="button" type="link" :title="strings.hubLinkTitle" :href="this.links.hub">{{ strings.hubLink }}</page-button>
    <page-button v-if='allowToCreateWorkspace' type="button" :title="strings.createNewWorkspaceTitle" id="home-btn-new" class="button primary" @click='handleNewWorkspace' v-bind:disabled="disableNewWorkspaceBtn">{{ strings.createNewWorkspaceText }}</page-button>
  </nav>
</template>

<script>
import navigation from '@/utils/navigation'
import { URLS } from '@/utils/urls'
import { CONST } from '@/utils/constants'
import PageButton from '@/components/common/Page-Button'
import { mapGetters, mapActions } from 'vuex'

export default {

  data () {
    return {
      assets: {
        hubLinkPlaceholder: `${process.env.BASE_URL}assets/images/placeholder-home-experience.svg`
      },
      strings: {
        hubLinkHeading: this.translate('home hub link heading'),
        hubLinkMessage: this.translate('home hub link message'),
        hubLink: this.translate('home hub link'),
        hubLinkTitle: this.translate('home hub link title'),
        createNewWorkspaceTitle: this.translate('new workspace title'),
        createNewWorkspaceText: this.translate('new workspace')
      },
      links: {
        hub: CONST.Services.Hosts.GWT + URLS.GWT.Hub(),
      }
    }
  },
  components: {
    'page-button': PageButton,
  },
  computed: {
    ...mapGetters({
      userId: 'user/userId',
      allowToCreateWorkspace: 'user/canNameWorkspace',
      newWorkspaceId: 'workspaces/newWorkspaceId',
    }),
    disableNewWorkspaceBtn () {
      return (this.newWorkspaceId === 'loading')
    }
  },
  methods: {
    async handleNewWorkspace () {
      try {
        await this.getNewWorkspaceId(this.userId)
        if (this.newWorkspaceId) navigation.redirect(CONST.Services.Hosts.GWT + URLS.GWT.Workspace(this.newWorkspaceId))
      } catch (err) {
        console.error('a workspace error:', err)
      }
    },
    translate (string, object) {
      return this.$i18n.translate(string, object)
    },
    ...mapActions({
      getNewWorkspaceId: 'workspaces/getNewWorkspaceId'
    })
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/components/home/_home-nav.scss";
</style>
